module.exports = __webpack_public_path__ + "static/media/strawberry-bg.da55cf76.jpg";